import { AppBar, Toolbar, Typography, Button, IconButton } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import PropTypes from "prop-types";
import MenuIcon from "@mui/icons-material/Menu";
import { useUser } from "../../contexts/UserContext";

const TopBar = ({ onLoginRedirect, onSidebarToggle }) => {
  const user = useUser();

  const handleLoginRedirect = () => onLoginRedirect();
  const handleSidebarToggle = () => onSidebarToggle();

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h5" component="div" sx={{ flexGrow: 1 }}>
          Shadowverse Memo
        </Typography>
        {user ? (
          <IconButton onClick={handleSidebarToggle}>
            <MenuIcon sx={{ color: "white" }} fontSize="large" />
          </IconButton>
        ) : (
          <Button
            color="inherit"
            endIcon={<LoginIcon />}
            onClick={handleLoginRedirect}
          >
            Login
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  onLoginRedirect: PropTypes.func.isRequired,
  onSidebarToggle: PropTypes.func.isRequired
};

export default TopBar;
